// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"d37fe339","239":"b53fa01b","667":"a798582e"}[chunkId] + ".chunk.js";
};